import Gallery3D from "../../../components/Gallery3D"
import TitleIcon from "./title.svg"

const Start = 0.5
const Tiles = [
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-1.jpg",
    path: "/assets/images/gallery/4-1.jpg",
    position: {
      x: 0 + Start,
      y: -0.2
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-2.jpg",
    path: "/assets/images/gallery/4-2.jpg",
    position: {
      x: 1.9 + Start,
      y: 0.2
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-3.jpg",
    path: "/assets/images/gallery/4-3.jpg",
    position: {
      x: 3.2 + Start,
      y: -0.18
    },
    title: {
      label:
        "Start your day with a flat white at Mousetail Coffee or a weekend brunch at Caravan. For after-work dinner with friends, try the stand-out tapas at Moro or classic British fare at St. John. To round off your night, head to The Zetter Townhouse hotel for cocktails, just round the corner from home.",
      position: { x: 0, y: 1.3 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-4.jpg",
    path: "/assets/images/gallery/4-4.jpg",
    position: {
      x: 5 + Start,
      y: 0
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-5.jpg",
    path: "/assets/images/gallery/4-5.jpg",
    position: {
      x: 6.7 + Start,
      y: -0.1
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-6.jpg",
    path: "/assets/images/gallery/4-6.jpg",
    position: {
      x: 8.3 + Start,
      y: 0
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-7.jpg",
    path: "/assets/images/gallery/4-7.jpg",
    position: {
      x: 10.3 + Start,
      y: 0
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-8.jpg",
    path: "/assets/images/gallery/4-8.jpg",
    position: {
      x: 11.9 + Start,
      y: 0.2
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-9.jpg",
    path: "/assets/images/gallery/4-9.jpg",
    position: {
      x: 13.7 + Start,
      y: 0
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-10.jpg",
    path: "/assets/images/gallery/4-10.jpg",
    position: {
      x: 15.3 + Start,
      y: 0
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-11.jpg",
    path: "/assets/images/gallery/4-11.jpg",
    position: {
      x: 17.1 + Start,
      y: 0
    },
    titleImg: {
      image: "/assets/images/gallery/placeholder/4-11_title.svg",
      position: { x: 0.6, y: 1.1 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-12.jpg",
    path: "/assets/images/gallery/4-12.jpg",
    position: {
      x: 18.8 + Start,
      y: 0
    },
    title: {
      label:
        "From notable flagships to highend<br/> hidden boutiques, there’s nowhere else<br/> in the world like London for shopping.",
      position: { x: 0.02, y: -0.05 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-13.jpg",
    path: "/assets/images/gallery/4-13.jpg",
    position: {
      x: 21 + Start,
      y: 0.1
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-14.jpg",
    path: "/assets/images/gallery/4-14.jpg",
    position: {
      x: 22.7 + Start,
      y: -0.1
    },
    title: {
      label:
        "For unusual gifts and accessories, browse the independent stores on Exmouth Market. Continue on to Coal Drops Yard for an eclectic mix of new and established brands and an al fresco lunch, or head south to Covent Garden’s charming pedestrianised streets for the latest designer boutiques and high-street names.",
      position: { x: -0.1, y: 1.2 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-15.jpg",
    path: "/assets/images/gallery/4-15.jpg",
    position: {
      x: 24.7 + Start,
      y: 0.2
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-16.jpg",
    path: "/assets/images/gallery/4-16.jpg",
    position: {
      x: 26.8 + Start,
      y: -0.2
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-17.jpg",
    path: "/assets/images/gallery/4-17.jpg",
    position: {
      x: 28.2 + Start,
      y: 0.2
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-18.jpg",
    path: "/assets/images/gallery/4-18.jpg",
    position: {
      x: 29.7 + Start,
      y: -0.2
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-19.jpg",
    path: "/assets/images/gallery/4-19.jpg",
    position: {
      x: 31.3 + Start,
      y: 0.2
    },
    titleImg: {
      image: "/assets/images/gallery/placeholder/4-19_title.svg",
      position: {
        x: -0.02,
        y: -0.1
      }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-20.jpg",
    path: "/assets/images/gallery/4-20.jpg",
    position: {
      x: 33.1 + Start,
      y: 0.1
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-21.jpg",
    path: "/assets/images/gallery/4-21.jpg",
    position: {
      x: 34.6 + Start,
      y: -0.1
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-22.jpg",
    path: "/assets/images/gallery/4-22.jpg",
    position: {
      x: 36.1 + Start,
      y: 0.2
    },
    title: {
      label:
        "Be inspired by a ground-breaking exhibition at the Barbican Centre followed by a lunchtime lecture at SOAS or Central St Martins. Head over to Bloomsbury to brush up on your human history at the British Museum, and finish with a spellbinding performance at Covent Garden’s stunning Royal Opera House.",
      position: {
        x: -0.02,
        y: -0.1
      }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-23.jpg",
    path: "/assets/images/gallery/4-23.jpg",
    position: {
      x: 37.9 + Start,
      y: 0
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-24.jpg",
    path: "/assets/images/gallery/4-24.jpg",
    position: {
      x: 39.4 + Start,
      y: 0.2
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-25.jpg",
    path: "/assets/images/gallery/4-25.jpg",
    position: {
      x: 41.3 + Start,
      y: 0
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-26.jpg",
    path: "/assets/images/gallery/4-26.jpg",
    position: {
      x: 42.9 + Start,
      y: 0.2
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-27.jpg",
    path: "/assets/images/gallery/4-27.jpg",
    position: {
      x: 44.4 + Start,
      y: -0.2
    },
    title: {
      label:
        "At the cutting edge of art, fashion and design,<br/> London has a deserving reputation as the<br/> cultural capital of the world.",
      position: {
        x: -0.01,
        y: 1.2
      }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-28.jpg",
    path: "/assets/images/gallery/4-28.jpg",
    position: {
      x: 46.5 + Start,
      y: 0.1
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-29.jpg",
    path: "/assets/images/gallery/4-29.jpg",
    position: {
      x: 48 + Start,
      y: -0.1
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/4-30.jpg",
    path: "/assets/images/gallery/4-30.jpg",
    position: {
      x: 49.9 + Start,
      y: 0.1
    }
  }
]

const TileData = {
  icon: TitleIcon,
  top: "5vw",
  left: "5vw",
  bottom: "auto",
  right: "auto",
  width: "43vw"
}

const LifestyleGallery = () => <Gallery3D title={TileData} tiles={Tiles} length={51.9} />

export default LifestyleGallery
